import { INTERNAL_HREF_PATTERN } from "@/libs/builder/consts";

export const inputs = [
  {
    name: "title",
    type: "string",
    required: true,
  },
  {
    name: "subtitle",
    type: "string",
    required: false,
  },
  {
    name: "callToAction",
    type: "object",
    subFields: [
      {
        name: "label",
        type: "string",
        required: true,
      },
      {
        name: "href",
        type: "url",
        required: true,
        regex: INTERNAL_HREF_PATTERN,
      },
    ],
    required: false,
  },
  {
    name: "backgroundImage",
    type: "file",
    allowedFileTypes: ["png"],
    required: false,
  },
] as const satisfies Inputs;

export type NotFoundBuilderProps = BuilderComponentProps<typeof inputs>;
